import React, { useContext, useState } from 'react';

const Footer = () => {
    return <>

        <div style={{ width: "100%", margin: "auto", background: "#333", padding: "60px 20px", boxSizing: "border-box" }}>
            <div style={{ maxWidth: 1200, width: "100%", margin: "auto" }}>
                <h1 style={{ color: "white", marginTop: 0, fontSize: 20, textDecoration: "none" }}>Contact Us</h1>
                <div><a style={{ color: "white", fontSize: 14, textDecoration: "none" }} href="mailto:Versatile@tbaytel.net ">Versatile@tbaytel.net </a></div>
                <div><a style={{ color: "white", fontSize: 14, textDecoration: "none" }} href="tel:18076262363">1 (807) 626-2363</a></div>
                <br></br>
                <div><a style={{ color: "white", fontSize: 14 }} href="https://www.facebook.com/versatileExpressDelivery/">Follow us on Facebook</a></div>
            </div>
        </div>
        <div style={{ width: "100%", margin: "auto", background: "#222", padding: "1px", textAlign: "center" }}>
            <div style={{ maxWidth: 1200, width: "100%", margin: "auto" }}>

                <p style={{ color: "white", fontSize: 12 }}>Copyright © 2023 The Versatile Express | <a style={{ color: "white" }} href="https://theversatileexpress.com/privacy-policy">Privacy Policy</a></p>
            </div>
        </div>

    </>;
}
export default Footer;